import { render, staticRenderFns } from "./ArmyByPriority.vue?vue&type=template&id=55c65800&scoped=true&"
import script from "./ArmyByPriority.vue?vue&type=script&lang=js&"
export * from "./ArmyByPriority.vue?vue&type=script&lang=js&"
import style0 from "./ArmyByPriority.vue?vue&type=style&index=0&id=55c65800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c65800",
  null
  
)

export default component.exports